/* Mikaya — homepage interactions: horizontal scrollers, category image cycling,
   learn video autoplay/unmute. Honors prefers-reduced-motion. */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Horizontal scrollers (drag / wheel / arrows / progress) ---------- */
  function initScrollers() {
    document.querySelectorAll('[data-scroller]').forEach(function (sc) {
      var track = sc.querySelector('[data-scroller-track]') || sc;
      var bar = sc.querySelector('[data-scroller-bar]');
      var section = sc.closest('section') || sc.parentElement;
      var prev = section && section.querySelector('[data-scroll-prev]');
      var next = section && section.querySelector('[data-scroll-next]');

      function amount() { return Math.max(track.clientWidth * 0.8, 280); }
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -amount(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: amount(), behavior: 'smooth' }); });

      // progress bar
      function updateBar() {
        if (!bar) return;
        var max = track.scrollWidth - track.clientWidth;
        var p = max > 0 ? track.scrollLeft / max : 0;
        bar.style.transform = 'scaleX(' + (0.12 + p * 0.88).toFixed(3) + ')';
      }
      track.addEventListener('scroll', updateBar, { passive: true });
      updateBar();

      // NOTE: no vertical-wheel→horizontal hijack — it blocked page up/down
      // scroll when the cursor was over a card. Carousels scroll via drag,
      // arrow buttons, and native trackpad-horizontal only.

      // prevent native image/link drag from hijacking the scroll
      track.addEventListener('dragstart', function (e) { e.preventDefault(); });

      // pointer drag — DON'T capture the pointer on a plain press (that swallows
      // clicks on cards / ATC buttons / links). Only enter drag mode + capture
      // once the pointer actually moves past a threshold.
      var down = false, dragging = false, startX = 0, startScroll = 0, pid = null;
      track.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'mouse' && e.button !== 0) return;
        down = true; dragging = false; startX = e.clientX; startScroll = track.scrollLeft; pid = e.pointerId;
      });
      track.addEventListener('pointermove', function (e) {
        if (!down) return;
        var dx = e.clientX - startX;
        if (!dragging && Math.abs(dx) > 6) {
          dragging = true;
          try { track.setPointerCapture(pid); } catch (err) {}
          track.classList.add('is-grabbing');
        }
        if (dragging) { track.scrollLeft = startScroll - dx; e.preventDefault(); }
      });
      function endDrag(e) {
        if (!down) return;
        down = false;
        if (dragging) { try { track.releasePointerCapture(pid); } catch (err) {} }
        track.classList.remove('is-grabbing');
      }
      track.addEventListener('pointerup', endDrag);
      track.addEventListener('pointercancel', endDrag);
      // suppress only the click that immediately follows a real drag
      track.addEventListener('click', function (e) {
        if (dragging) { e.preventDefault(); e.stopPropagation(); dragging = false; }
      }, true);
    });
  }

  /* ---------- Category card image cycling ---------- */
  function initCycle() {
    var groups = document.querySelectorAll('[data-cycle]');
    if (!groups.length) return;
    groups.forEach(function (g, gi) {
      var imgs = g.querySelectorAll('.mk-cat__img');
      if (imgs.length < 2) { if (imgs[0]) imgs[0].classList.add('is-active'); return; }
      imgs[0].classList.add('is-active');
      if (reduce) return;
      var idx = 0, timer = null;
      function tick() {
        imgs[idx].classList.remove('is-active');
        idx = (idx + 1) % imgs.length;
        imgs[idx].classList.add('is-active');
      }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting && !timer) {
            timer = setInterval(tick, 2600);
          } else if (!e.isIntersecting && timer) {
            clearInterval(timer); timer = null;
          }
        });
      }, { threshold: 0.2 });
      // stagger start
      setTimeout(function () { io.observe(g); }, (gi % 5) * 400);
    });
  }

  /* ---------- Learn video: autoplay muted on scroll + unmute toggle ---------- */
  function initLearnVideo() {
    document.querySelectorAll('[data-mk-video]').forEach(function (wrap) {
      var video = wrap.querySelector('video');
      if (!video) return;
      var btn = wrap.querySelector('[data-mk-sound]');
      video.muted = true;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { var p = video.play(); if (p && p.catch) p.catch(function () {}); }
          else { video.pause(); }
        });
      }, { threshold: 0.35 });
      io.observe(video);
      if (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault(); e.stopPropagation();
          video.muted = !video.muted;
          if (!video.muted) { video.play(); }
          wrap.classList.toggle('is-muted', video.muted);
          btn.setAttribute('aria-pressed', String(!video.muted));
        });
        wrap.classList.add('is-muted');
      }
    });
  }

  function init() { initScrollers(); initCycle(); initLearnVideo(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
